<div class="dz-grid">
	<div class="dz-row" [ngClass]="enableAddToCompareModel && selectedModels.length !== 3 ? ' dz-justify-content-center' : 'dz-justify-content-right'">
		<div
			*ngFor="let model of selectedModels; let i = index"
			[ngClass]="
				selectedModels.length === ApplicationConstants.MAX_MODELS_FOR_COMPARISON || (enableAddToCompareModel && selectedModels.length !== 1) ? 'dz-col-sm-6' : 'dz-col-sm-8'
			"
		>
			<dz-select
				[label]="'Model' | dcr : 'MINI_COMPARE_DROPDOWN_LABEL'"
				[dcrKeys]="['MINI_COMPARE_DROPDOWN_LABEL']"
				[placeholder]="model.familyName"
				(valueChange)="onSelectedFamilyChange($event, i)"
			>
				<dz-option *ngFor="let family of familyList" [value]="family" [disabled]="family?.disabled">
					<span [ngClass]="{ 'dz-text-14-bold': family?.disabled }">{{ family.familyName }}</span>
				</dz-option>
			</dz-select>
		</div>
	</div>
</div>
